import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, type LayoutChangeEvent } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconInfoCircle, IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
const theme = createDSTheme();

function UnavailabilityBanner({
  onDismiss,
  onHeightChange,
  withInsets = false,
}: {
  onDismiss?: () => void;
  onHeightChange?: (height: number) => void;
  withInsets?: boolean;
}) {
  const [isShown, setIsShown] = React.useState(true);
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();

  if (!isShown) return null;

  return (
    <Row
      alignItems="center"
      onLayout={(event: LayoutChangeEvent) => onHeightChange?.(event.nativeEvent.layout.height)}
      paddingHorizontal="spacing.general.x2"
      style={{
        backgroundColor: theme.colors['surface.brand.secondary-2.default'],
        paddingTop: (withInsets ? insets.top : 0) + theme.spacing['spacing.general.x2'],
        paddingBottom: theme.spacing['spacing.general.x4'],
      }}
      gap="spacing.general.x4"
    >
      <IconInfoCircle strokeWidth={ICON_STROKE_WIDTH} size={28} color={theme.colors['text.primary']} />
      <Text flex={1} style={{ color: theme.colors['text.primary'] }}>
        {t('unavailabilityBannerMessage', { ns: 'neighbour-profile' })}
      </Text>

      <Pressable
        onPress={() => {
          setIsShown(false);
          onDismiss?.();
        }}
      >
        <IconX strokeWidth={ICON_STROKE_WIDTH} size={24} color={theme.colors['text.primary']} />
      </Pressable>
    </Row>
  );
}

export default UnavailabilityBanner;
